const SecTelegramText = () => {

  return (
    <div className="col-lg-5 col-lg-offset-1 col-sm-12 text-center">
        <span className="telegram-text">Join our chat: </span>
        <a href="https://t.me/GreenEarthMetaverse" className="button"><i className="fa fa-telegram"></i>Telegram</a>
    </div>
  );
}

export default SecTelegramText;